(ns kyber.lib.pdftron.get-viewport-rect
  (:require [goog.object :as gobj]))

(defn get-viewport-rect
  [{:keys [doc-viewer annotations internal-state]}]
  (let [{:keys [scroll-view-element]}
        @internal-state

        Rect
        (gobj/get annotations "Rect")

        zoom
        (js-invoke doc-viewer "getZoom")

        scroll-top
        (gobj/get scroll-view-element "scrollTop")

        scroll-left
        (gobj/get scroll-view-element "scrollLeft")

        client-width
        (gobj/get scroll-view-element "clientWidth")

        client-height
        (gobj/get scroll-view-element "clientHeight")

        page-margin
        4

        top-offset
        (+ (/ scroll-top zoom) page-margin)

        left-offset
        (+ (/ scroll-left zoom) page-margin)

        viewport-rect
        (new Rect
             left-offset
             top-offset
             (+ left-offset (/ client-width zoom))
             (+ top-offset (/ client-height zoom)))]
    {:x1 (gobj/get viewport-rect "x1")
     :y1 (gobj/get viewport-rect "y1")
     :x2 (gobj/get viewport-rect "x2")
     :y2 (gobj/get viewport-rect "y2")}))
